<template>
	<div v-if="payment" v-loading="loading">
		<div class="text-center" v-if="payment.statusId !== 'PS_CANCELLED'">
			<h2 class="mb-2">Membership Status:</h2><h2 v-html="payment.statusMessage"></h2><h2 v-html="payment.passCards"></h2>
			
			<!--<h5>{{payment.studio}}</h5>-->
		</div>
		

		<div v-if="payment.statusId === 'PS_ACTIVE' && payment.futureStatus === 'n/a'" class="text-center">
			<br /><p class="lead">What would you like to do, {{user.firstname}}?</p><br />
			<!--<el-button :disabled="!isViewingOwnProfile || payment.futureStatusDate !== 'n/a'" type="link" @click="dialog.location = true" class="mb-3" style="width: 230px">Change My Location</el-button>-->
			<div @click="dialog.plan = true" class="btn btn-lg btn-block btn-primary mb-2 text-center" style="margin:auto"><h4>Change My Plan</h4></div>
			<div @click="dialog.family = true" class="btn btn-lg btn-block btn-primary" style="margin:auto"><h4>Add/Remove Family Member</h4></div><br />
			<div @click="dialog.plan = true" class="btn btn-lg btn-block btn-primary" style="margin:auto"><h4>Cancel My Membership</h4></div>

			<!--<el-button :disabled="!isViewingOwnProfile || payment.futureStatusDate !== 'n/a'" type="button" @click="dialog.plan = true" class="btn btn-primary">Change My Plan</el-button>-->
			<!--<el-button :disabled="!isViewingOwnProfile || payment.futureStatusDate !== 'n/a'" type="link" @click="dialog.family = true" class="mb-3">Add/Remove Family Member</el-button>-->
		</div>
		<div v-else-if="user.acceptText === 'Test' && payment.statusId === 'PS_CANCELLED'" class="text-center">
			<div @click="dialog.plan = true" class="btn btn-lg btn-block btn-primary mb-2 text-center" style="margin:auto"><h4>Click to Purchase Your Special Offer!</h4></div>
			<!--<p class="lead">What would you like to do, {{user.firstname}}?</p>-->
			<!--<el-button :disabled="!isViewingOwnProfile" type="link" @click="dialog.plan = true" class="btn btn-primary" style="width: 230px">Select a Membership</el-button>-->
			<!--<el-button type="link" @click="dialog.plan = true" class="mb-3 btn-primary" style="width: 230px">Select a Membership</el-button>-->
		</div>
		<div v-else class="text-center">
			<div @click="dialog.plan = true" class="btn btn-lg btn-block btn-primary mb-2 text-center" style="margin:auto"><h4>Click to Purchase a new Membership, Pass or Class Card</h4></div>
			<!--<el-button @click="dialog.plan = true" class="btn btn-primary">Click to Select a Membership, Pass or Class Card</el-button>-->
	
	<!--<p class="lead">What would you like to do, {{user.firstname}}?</p>-->
			<!--<el-button :disabled="!isViewingOwnProfile" type="link" @click="dialog.plan = true" class="btn btn-primary" style="width: 230px">Select a Membership</el-button>-->
			<!--<el-button type="link" @click="dialog.plan = true" class="mb-3 btn-primary" style="width: 230px">Select a Membership</el-button>-->
		</div>

		<div class="row mt-4" v-if="payment.futureStatus === null">
			<div class="col text-center">
				<router-link tag="a" class="text-primary" :to="{ name: 'dashboard'}">Back to Account</router-link>
			</div>
		</div>

		<membership-location :user="user" :payment="payment" @fetch="fetch($event)"></membership-location>
		<membership-plan :user="user" :payment="payment" @fetch="fetch($event)" @cancelMembership="cancelMembership"></membership-plan>
		<membership-family :user="user" :payment="payment" @fetch="fetch($event)"></membership-family>

	</div>
	

</template>

<script>

	import { rest } from "@/utilities/rest.js";
	import { mapGetters, mapActions } from "vuex";
	import Location from "./location";
	import Plan from "./plan";
	import Family from "./family";

	export default {
		name: "manage-membership",
		data() {
			return {
				serverError: null,
				dialog: {
					location: false,
					plan: false,
					family: false
				},

				loading: false,

				thinking: {
					save: false
				}
			}
		},
		components: {
			[Location.name]: Location,
			[Plan.name]: Plan,
			[Family.name]: Family
		},

		created() {
			if (!this.user || !this.payment) {
				this.$router.push({ name: "dashboard" });
			}
		},

		computed: {
			...mapGetters({
				user: "user",
				payment: "payment",
				familyMembers: "familyMembers",
				modalWidth: "modalWidth"
			}),

			isViewingOwnProfile() {
				return window.sunstonevNext.apps.account.data.urlId === window.sunstonevNext.apps.account.data.userId;
			}
		},

		methods: {
			...mapActions({
				getPayment: "getPayment"
			}),

			fetch(which) {
				this.loading = true;
				this.getPayment(window.sunstonevNext.apps.account.data.urlId).then(response => {
					setTimeout(() => {
						this.loading = false;
					}, 500);
				}, error => {
						
				});
			},

			cancelMembership(confirm) {
				this.dialog.plan = false;
				if (!confirm) {
					
					this.$confirm('Are you sure you want to cancel your membership?', 'Please Confirm', {
						confirmButtonText: 'Yes',
						cancelButtonText: 'Cancel',
						type: 'warning'
					}).then(() => {

						let formData = {
							userId: this.user.userId
						};

						rest.post("Account", "/CancelMembership", "json", JSON.stringify(formData)).done(response => {
							setTimeout(() => {
								this.$message.success("Changes have been saved.");
							}, 1000);
							//this.$emit("fetch");
							this.$router.push({ name: 'dashboard' });
						}).fail((error) => {
							alert(JSON.parse(error.responseText));
						});
					}).catch(() => {

					});
				}
			}
		}
	}

</script>

<style scoped>
</style>